import {Component} from '../component.interface';
import {AutocompleteDomInjector} from './autocomplete-dom-injector';
import {HttpClientService} from '../http-client/http-client.service';
import {SearchResult} from './model/search-result.model';
import {AutocompleteConfig} from './config/autocomplete-config.interface';
import {Observable} from 'rxjs';

export class Autocomplete implements Component {
    static readonly AUTOCOMPLETE_APPLICATION_URI = `search`;

    bootstrapped = false;
    autocompleteDomInjector: AutocompleteDomInjector;

    constructor(
        private window: Window,
        private document: Document,
        private http: HttpClientService = null,
        public config: AutocompleteConfig
    ) {
    }

    init(): void {
        if (this.http === null) {
            throw new Error('Autocomplete requires http service');
        }
    }

    injectDom(hostElement?: HTMLDivElement): void {
        this.autocompleteDomInjector = new AutocompleteDomInjector(this.document, this.window, hostElement, this);
    }

    getSearchResult(q: string): Observable<SearchResult> {
        return this.http.get(Autocomplete.AUTOCOMPLETE_APPLICATION_URI, {
            q,
            groupid: this.config.groupId,
            end: this.config.maxResults
        });
    }

    empty(): void {
        this.autocompleteDomInjector.empty();
    }
}